import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Tag, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useGetCountries } from 'api/countries/use-get-countries.ts';
import type { WarehouseRes } from 'api/swagger';
import { useTransformToTableData } from 'shared/hooks/use-transform-to-table-data';
import { findCountriesById } from 'shared/utils/countries';
import type { IWarehousesListProps } from './types';
import styles from './warehouse-list.module.scss';

export const WarehouseList: React.FC<IWarehousesListProps> = (props) => {
  const { warehouses, isLoading } = props;
  const { t } = useTranslation();
  const { data: countries } = useGetCountries();
  const tableData = useTransformToTableData(warehouses);

  const columns: ColumnsType<WarehouseRes> = [
    {
      title: t('common:name'),
      dataIndex: 'name',
      width: '30%',
      render: (name: string) => <Typography.Text>{name}</Typography.Text>,
    },

    {
      title: t('common:country'),
      dataIndex: 'countryId',
      render: (countryId) => {
        const country = findCountriesById(countryId, countries);
        return <Typography.Text>{country?.name}</Typography.Text>;
      },
    },
    {
      title: t('common:address'),
      dataIndex: 'address',
      render: (_, data) => {
        return (
          <Typography.Text>
            <Tag>{data.postCode}</Tag> {data.city}, {data.address}
          </Typography.Text>
        );
      },
    },
    {
      title: t('common:type'),
      dataIndex: 'type',
      render: (type) => {
        return <Typography.Text className={styles.type}>{type}</Typography.Text>;
      },
    },
  ];

  return (
    <div>
      <Table
        size={'small'}
        columns={columns}
        dataSource={tableData}
        pagination={false}
        rowClassName={(record) => (record.deprecated ? styles.deprecatedRow : '')}
        loading={isLoading ? { size: 'large', delay: 200 } : false}
        bordered
      />
    </div>
  );
};
